import { parse, isValid } from 'date-fns'

/**
 * Converte uma data para o formato ISO completo com timezone Z (ex: 2026-03-06T18:17:43.471Z).
 * Aceita: yyyy-MM-dd, dd/MM/yyyy ou já em formato ISO.
 */
export const toReferenceDateIso = (dateStr: string): string => {
  if (!dateStr || !dateStr.trim()) return ''

  const s = dateStr.trim()

  // Já está em ISO completo (contém T e Z)
  if (s.includes('T') && s.includes('Z')) return s

  // ISO sem Z (ex: 2026-03-06T18:17:43.471) — normaliza para ISO completo
  if (s.includes('T')) {
    const d = new Date(s)
    return isNaN(d.getTime()) ? '' : d.toISOString()
  }

  // yyyy-MM-dd
  if (s.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return new Date(`${s}T00:00:00.000Z`).toISOString()
  }

  // dd/MM/yyyy
  if (s.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
    const date = parse(s, 'dd/MM/yyyy', new Date())
    return isValid(date) ? date.toISOString() : ''
  }

  const d = new Date(s)
  return isNaN(d.getTime()) ? '' : d.toISOString()
}
